import { env } from '~/env'

/**
 * #554 — which social sign-in providers render on /login and /signup.
 *
 * Facebook and Apple are configured in code but their Supabase providers are
 * not enabled yet (V-2 #592 / V-3 #591), so their buttons would die on a raw
 * provider error. The allowlist lives in NEXT_PUBLIC_ENABLED_SSO_PROVIDERS
 * (comma-separated, e.g. "google,apple") so enabling a provider later is an
 * env change + redeploy — no code change (the AC of #554). Unset ⇒ Google
 * only, the one provider live today.
 *
 * NEXT_PUBLIC_* is inlined at build time; Cloud66 builds from the repo on
 * deploy, so flipping the stack env var and redeploying is the whole
 * procedure.
 */
export type SsoProvider = 'google' | 'facebook' | 'apple'

const DEFAULT_ENABLED: readonly SsoProvider[] = ['google']

function enabledProviders(): ReadonlySet<string> {
  const raw = env.NEXT_PUBLIC_ENABLED_SSO_PROVIDERS
  if (!raw || raw.trim() === '') return new Set(DEFAULT_ENABLED)
  return new Set(
    raw
      .split(',')
      .map((p) => p.trim().toLowerCase())
      .filter(Boolean),
  )
}

export function isSsoProviderEnabled(provider: SsoProvider): boolean {
  return enabledProviders().has(provider)
}
